/* Account Users */
export const GET_ACCOUNT_USER = "GET_ACCOUNT_USER";
export const GET_ACCOUNT_USER_SUCCESS = "GET_ACCOUNT_USER_SUCCESS";
export const GET_ACCOUNT_USER_ERROR = "GET_ACCOUNT_USER_ERROR";

export const GET_ACCOUNT_USERS = "GET_ACCOUNT_USERS";
export const GET_ACCOUNT_USERS_SUCCESS = "GET_ACCOUNT_USERS_SUCCESS";
export const GET_ACCOUNT_USERS_ERROR = "GET_ACCOUNT_USERS_ERROR";

export const ADD_ACCOUNT_USER = "ADD_ACCOUNT_USER";
export const ADD_ACCOUNT_USER_SUCCESS = "ADD_ACCOUNT_USER_SUCCESS";
export const ADD_ACCOUNT_USER_ERROR = "ADD_ACCOUNT_USER_ERROR";

export const DELETE_ACCOUNT_USER = "DELETE_ACCOUNT_USER";
export const DELETE_ACCOUNT_USER_SUCCESS = "DELETE_ACCOUNT_USER_SUCCESS";
export const DELETE_ACCOUNT_USER_ERROR = "DELETE_ACCOUNT_USER_ERROR";
